import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Header from "../../../../components/Header/index";
import Footer from "../../../../components/Footer/index";
import GameItem from "../components/GameItem";
import GameFaq from "../components/GameFaq";
import styles from "./index.module.scss";
import gameMock from "../components/GameItem/gameMock";

const gameBanner = require('../../../../static/images/game_banner.jpg')
const gameAdBanner = require('../../../../static/images/game_ad_banner.jpg')
const categoryImg = require('../../../../static/images/game_pic.jpg')

interface IFaqItem {
  id?: string,
  title: string,
  content: string
}
const faqList: Array<IFaqItem> = [
  {
    id: '1',
    title: 'Are games in VR free?Are VR games expensive?',
    content: "PICO 4 is currently available for purchase in: United Kingdom, Germany, France, Finland, Denmark, Sweden, Norway, Spain, Italy, Netherlands, Belgium, Austria, Switzerland, Poland, Portugal, Japan, Korea, Singapore, Malaysia."
  },
  {
    id: '2',
    title: 'How do l get games for my PICO VR?',
    content: "PICO 4 is currently available for purchase in: United Kingdom, Germany, France, Finland, Denmark, Sweden, Norway, Spain, Italy, Netherlands, Belgium, Austria, Switzerland, Poland, Portugal, Japan, Korea, Singapore, Malaysia."
  },
  {
    id: '3',
    title: 'Can l play VR online with friends?',
    content: "PICO 4 is currently available for purchase in: United Kingdom, Germany, France, Finland, Denmark, Sweden, Norway, Spain, Italy, Netherlands, Belgium, Austria, Switzerland, Poland, Portugal, Japan, Korea, Singapore, Malaysia."
  },
  {
    id: '4',
    title: 'What VR games can be play with non VR friends?',
    content: "PICO 4 is currently available for purchase in: United Kingdom, Germany, France, Finland, Denmark, Sweden, Norway, Spain, Italy, Netherlands, Belgium, Austria, Switzerland, Poland, Portugal, Japan, Korea, Singapore, Malaysia."
  }
]
interface IObj {
  [key:string]:string
}
const categoryList: Array<IObj> = [
  {id: '1', img: categoryImg, name: 'New release'},
  {id: '2', img: categoryImg, name: 'Shooting'},
  {id: '3', img: categoryImg, name: 'Horror and adventure'},
  {id: '4', img: categoryImg, name: 'Entertainment'},
  {id: '5', img: categoryImg, name: 'Sports and fitness'},
  {id: '6', img: categoryImg, name: 'All'},
]
const Game = (props: any) => {
  const {ctry, words} = props.data
  return (
    <div>
      <Helmet>
        {/* <title>{words.support_tilte}</title>
        <meta name="description" content={words.blog_description} />
        <meta name="keywords" content={words.blog_keywods} /> */}
      </Helmet>
      <Header ctry={ctry} words={words}/>
      <main className={styles['game-wrap']}>
        {/* banner区 */}
        <div className={styles["banner-wrap"]}>
          <img src={gameBanner} alt="banner_img" className={styles['banner-img']} />
        </div>
        {/* 内容区 */}
        <div className={styles["game-content"]}>
          <div className={styles["search-wrap"]}>
            <div className={styles["search"]}>
              <i className={styles['search-icon']}></i>
              <input type="text" placeholder="Please enter your question" />
            </div>
            <div className={styles["quick-search"]}>
              <span className={styles["quick-search-item"]}>All</span>
              <span className={styles["quick-search-item"]}>Final Fantasy 14</span>
              <span className={styles["quick-search-item"]}>The Legend of Zelda</span>
              <span className={styles["quick-search-item"]}>Elden Ring</span>
              <span className={styles["quick-search-item"]}>Final Fantasy XVI</span>
              <span className={styles["quick-search-item"]}>Fire Emblem: ThreeHouses</span>
            </div>
          </div>
          {gameMock.length && (
            <section className={`${styles['game-section']} ${styles['game-section-list']}`}>
              {gameMock.slice(0,7).map((item, index) => {
                if(index === 0 || index === 4){
                  return(
                    <GameItem
                    key={item.id}
                    gameData={item}
                    className={styles['game-1']}
                    contentClassName={styles['custom-item-content']}></GameItem>
                  )
                } else if([1,2,3].includes(index)){
                  return(
                    <GameItem
                    key={item.id}
                    gameData={item}
                    className={styles['game-3']}
                    contentClassName={styles['custom-item-content']}></GameItem>
                  )
                } else {
                  return(
                    <GameItem
                    key={item.id}
                    gameData={item}
                    className={styles['game-2']}
                    contentClassName={styles['custom-item-content']}></GameItem>
                  )
                }
              })}
            </section>
          )}

          <div className={styles['game-banner']}>
            <img className={styles['game-banner-img']} src={gameAdBanner} alt="" />
            <div className={styles['game-banner-content']}>
              <h2 className={styles['game-banner-title']}>Not miss out to be a gaming expert</h2>
              <span className={styles['load-more-purple']}>Read more</span>
            </div>
          </div>

          <section className={`${styles['game-section']} ${styles['game-faq']}`}>
            <h2 className={styles['section-title']}>Frequently asked question</h2>
            <div className={styles['faq-list']}>
              {faqList.map(item => (
                <GameFaq FaqList={item} key={item.id}></GameFaq>
              ))}
            </div>
          </section>

          <section className={`${styles['game-section']} ${styles['more-games']}`}>
            <h2 className={styles['section-title']}>Discover more VR games</h2>
            <div className={styles['more-game-list']}>
              {categoryList.map(item => (
                <div className={styles['game-item']} key={item.id}>
                  <img className={styles['game-pic']} src={item.img} alt="" />
                  <p className={styles['game-title']}>{item.name}</p>
                </div>
              ))}
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
};
Game.getInitialProps = () => {
  return new Promise((resolev, reject) => {
    setTimeout(() => {
      resolev({ title: "游戏" });
    }, 200);
  });
};
export default Game;
